import { nextId, Position } from './Helpers';

/**
 * @typedef {{
 *    zIndex?: number,
 *    appendToBody?: boolean,
 *    position?: string,
 *    positionOffset?: [number, number],
 *    autoWidth?: boolean
 * }} PopoverOptions
 */

const PopoverOptionsDefault = {
    zIndex: 1010,
    appendToBody: true,
    position: `${Position.BOTTOM}-${Position.START}`,
    positionOffset: [1, 1],
    autoWidth: false
};

export default {
    props: {
        /**
         * z-index
         */
        zIndex: {
            type: Number,
            default: 1010,
        },
        /**
         * Dropdown append to body
         */
        appendToBody: {
            type: Boolean,
            default: true,
        },
        /**
         * Position, values of the popover:
         * bl, br, tl, tr - bottom-left, bottom-right, top-left, top-right
         * @values bl, br, tl, tr, top, top-start, top-end, left, left-start, left-end, right, right-start, right-end, bottom, bottom-start, bottom-end
         */
        position: {
            type: String,
            default: `${Position.BOTTOM}-${Position.START}`,
        },
        /**
         * Position offset [ x, y ] where:
         * x - skidding (offset along target)
         * y - distance (offset away from target)
         */
        positionOffset: {
            type: Array,
            default() {
                return [1, 1];
            },
        },
        /**
         * Auto width
         */
        autoWidth: {
            type: Boolean,
            default: false,
        },
        popover: {
            type: Object,
            default: () => ({
                /*
                zIndex: -1,
                appendToBody: true,
                position: `${Position.BOTTOM}-${Position.START}`,
                positionOffset: [1, 1],
                autoWidth: false
                */
            }),
        }
    },
    data() {
        return {
            popoverShow: false,
            popoverTargetId: nextId('popover-target'),
        };
    },
    computed: {
        popoverTarget() {
            return `[data-popover=${this.popoverTargetId}]`;
        },
        popoverOptions() {
            const {
                zIndex,
                appendToBody,
                position,
                positionOffset,
                autoWidth,
                popoverTarget: target,
                popover
            } = this;
            return {
                ...PopoverOptionsDefault,
                zIndex,
                appendToBody,
                position,
                positionOffset,
                autoWidth,
                target,
                ...popover
            };
        },
    },
    methods: {
        togglePopover() {
            this.popoverShow = !this.popoverShow;
        },
    },
};
